import { Link } from 'react-router-dom';
import { Mail, MapPin } from 'lucide-react';
import './Footer.css';
import pidesk_logo from '../assets/pidesk_logo.png';

const columns = [
  {
    title: 'Explore',
    links: [
      { name: 'Services', to: '/services' },
      { name: 'Products', to: '/products' },
      { name: 'Blog', to: '/blog' },
      { name: 'Pricing', to: '/pricing' },
      { name: 'DCIC Community', to: '/dcic' }
    ]
  },
  {
    title: 'Company',
    links: [
      { name: 'About', to: '/about' },
      { name: 'Careers', to: '/join' },
      { name: 'Contact', to: '/contact' }
    ]
  },
  {
    title: 'Legal',
    links: [
      { name: 'Privacy Policy', to: '/privacy-policy' },
      { name: 'Terms & Conditions', to: '/terms-and-conditions' },
      { name: 'Refund Policy', to: '/refund-policy' }
    ]
  }
];

const Footer = () => (
  <footer className="footer">
    <div className="container footer-container">
      <div className="footer-grid">
        <div className="footer-brand">
          <Link to="/" className="brand-logo">
            <img src={pidesk_logo} alt="Pidesk" className="brand-img" />
          </Link>
          <p className="footer-description">
            Software, websites and apps for businesses, colleges and organizations.
          </p>
          <span className="footer-status"><i></i> Accepting new projects</span>

          <ul className="footer-contact">
            <li><Mail size={16} /> <a href="mailto:hq@pidesk.in">hq@pidesk.in</a></li>
            {/* <li><MapPin size={16} /> Innovation Hub, Tech City, India</li> */}
          </ul>
        </div>

        {columns.map((col) => (
          <nav key={col.title} className="footer-links-group" aria-label={col.title}>
            <h4 className="footer-title">{col.title}</h4>
            <ul className="footer-list">
              {col.links.map((l) => (
                <li key={l.name}><Link to={l.to}>{l.name}</Link></li>
              ))}
            </ul>
          </nav>
        ))}
      </div>

      <div className="footer-bottom">
        <p>&copy; {new Date().getFullYear()} Pidesk. All rights reserved.</p>
        <p>Built with care in India.</p>
      </div>
    </div>

    <div className="footer-mark" aria-hidden="true">pidesk</div>
  </footer>
);

export default Footer;
